import { ArticleMode, ArticleModeRouteNames, ArticleModeRubriqueTypes, RubriqueForm } from 'core/models';
import { rubriqueService } from 'core/services';
import React from 'react';
import { useHistory } from 'react-router';
import ActualiteRubriqueForm from '../Form';

type Props = {
    mode: ArticleMode;
};

const ActualiteRubriqueCreate: React.FC<Props> = ({ mode }) => {
    const history = useHistory();

    const onSubmit = (rubrique: RubriqueForm) => {
        rubriqueService.createRubrique(rubrique).then(() => history.push(`/${ArticleModeRouteNames[mode]}/rubriques`));
    };

    return (
        <ActualiteRubriqueForm
            mode={mode}
            defaultValues={{ type: ArticleModeRubriqueTypes[mode] }}
            onCreate={onSubmit}
        ></ActualiteRubriqueForm>
    );
};

export default ActualiteRubriqueCreate;
